import type { PersonaHelperRole } from "@src/packages/persona/useUserPersona";

const DEV_OVERRIDE_KEY = "__moon_dev_helperRole";

// Captured at module load time, before React Navigation's linking config
// canonicalizes the URL and drops the query param. Persisted in
// sessionStorage so route changes / hot-reloads keep the override for the
// life of the browser tab.
export const DEV_HELPER_ROLE_OVERRIDE: PersonaHelperRole = (() => {
  if (!__DEV__ || typeof window === "undefined") return null;
  const fromUrl = new URLSearchParams(window.location.search).get(
    "dev_helperRole",
  );
  if (
    fromUrl === "donor" ||
    fromUrl === "carrier" ||
    fromUrl === "intended-parent"
  ) {
    try {
      window.sessionStorage?.setItem(DEV_OVERRIDE_KEY, fromUrl);
    } catch {
      /* sessionStorage may be disabled — fall through */
    }
    return fromUrl;
  }
  try {
    const stored = window.sessionStorage?.getItem(DEV_OVERRIDE_KEY);
    if (
      stored === "donor" ||
      stored === "carrier" ||
      stored === "intended-parent"
    ) {
      return stored;
    }
  } catch {
    /* sessionStorage may be disabled */
  }
  return null;
})();
